const Order = ({ order }) => {
	return (
		<div>
			<div className="history1">
				{order.progress === "Delivered" || order.progress === "Pick-Up" ? (
					<span className="btn btn-success">{order.progress}</span>
				) : order.progress === "Cancelled" ? (
					<span className="btn btn-danger">{order.progress}</span>
				) : (
					<span className="btn btn-warning">{order.progress}</span>
				)}

				<span className="food_detail1" style={{ textAlign: "right" }}>
					<b> {order.created_at}</b>
				</span>
			</div>

			<div className="row fda_section_row bor">
				<div className="col-12 history">
					<span className="product_title" style={{ textAlign: "right" }}>
						<i>Order ID: {order.order_id}</i>
					</span>
					{order.order.map((d) => {
						return (
							<span className="product_title" key={d.id}>
								<i className="fa fa-leaf" style={{ color: "green" }}></i> &nbsp;
								<span>{d.quantity} x</span> {d.dish_name}
							</span>
						);
					})}
					<div className="price2">
						<span className="price1">
							<i className="fa fa-inr"></i> {order.price}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Order;
